const formStep = 'js-form-step';
const activeClass = 'js-form-step-active';
const initStep = document.querySelectorAll(`.${formStep}`);

if (initStep) {
  initStep.forEach((element) => {
    const form = element.closest('form');
    const inputIsDoctor = form.querySelector('#id-is-doctor input');

    inputIsDoctor.addEventListener('click', () => {
      element.classList.toggle(formStep)
    })
  })
}
